import { Box } from '@mui/material';
import _ from 'lodash';
import { useCallback, useState } from 'react';
import * as setup from 'setup';
import { useInterval } from 'usehooks-ts';
import GameCard from '../GameCard/GameCard';
import { Container } from './LandingCards.styled';

export default function LandingCards() {
    const [compact, setCompact] = useState(false);
    const [types, setTypes] = useState<GameCardType[]>([]);

    const update = useCallback(() => {
        if (compact && types.length === 0) {
            setCompact(false);
        } else if (types.length < 3) {
            const next = _.sampleSize(setup.cards.deck, 1);
            const newTypes = types.concat(next);
            setTypes(newTypes);
        } else {
            setCompact(true);
            setTypes([]);
        }
    }, [compact, types]);

    useInterval(update, types.length && types.length < 3 ? 500 : 1500);

    return (
        <Box
            aria-label="Animated illustration of three cards"
            display="flex"
            flex={1}
            gap={1}
            justifyContent="center"
            paddingTop={8}
            role="img"
        >
            <Container $offset={compact ? 1 : 0}>
                <GameCard bare name="landing-1" side="front" type={types[0]} />
            </Container>
            <Container>
                <GameCard bare name="landing-2" side="front" type={types[1]} />
            </Container>
            <Container $offset={compact ? -1 : 0}>
                <GameCard bare name="landing-3" side="front" type={types[2]} />
            </Container>
        </Box>
    );
}
